import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Profile from '@/plugins/sdk/resources/Profile'

export default class extends Resource {
  static name = 'note'

  static get fields () {
    return {
      id: new UUID(),
      content: new STRING(),
      resource: new STRING(),
      resource_uuid: new UUID(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      creator: new ITEM(Profile)
    }
  }
}
